<template>
    <div style="padding-top: 5vh; text-align: center">
        <img
            id="logo"
            src="@/assets/icons/WorkstateLightBlue.ico"
            alt="App Icon"
        />
    </div>
</template>

<script setup lang="ts">
</script>

<style>
#logo {
    height: 15vh;
}
</style>